import { RecordContextType } from "../../components/record/Record";

export const operationalCentersOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["id"],
    },
    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "bank_transaction",
                sort: "transaction_date",
                enabled: true,
            },
        ],
    },
};

const createOperationalCenterParams = async (recordContext: RecordContextType | undefined) => {
    if (!recordContext?.item) return;
    if (recordContext.entity === "bank_transactions") {
        return `[bank_transactions][id]=${recordContext.item.id}`;
    }
};

export const bankTransactionOperationalCentersOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["id", "bank_transaction"],
    },
    createRelatedParams: (params: RecordContextType | undefined) => createOperationalCenterParams(params),
};

